import { Component, inject } from '@angular/core';
import { Link } from '@core/models/atomics.model';
import { LinkComponent } from '@shared/components/link/link.component';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';

@Component({
  selector: 'cx-term-link',
  templateUrl: './cx-term-link.component.html',
  styleUrls: ['./cx-term-link.component.scss'],
  imports: [LinkComponent],
})
export class CxTermLinkComponent {
  protected data = inject<Link>(CX_ABSTRACT_COMPONENT_DATA);
}
